import SignInActivityScreen from 'components/SignIn/SignInActivityScreen';

export default SignInActivityScreen;
